import { ClientComplaintsActionTypes } from './complaints-actions';

export const initialState = {
  complaintsList: [],
  dataLoading: true,
  currentPage: 1,
  lastPage: 0,
  extendedListLoading: false,
  complaintsModal: false,
  complaintsRequest: {
    type_id: null,
    order_id: null,
    title: null,
    description: null,
  },
  complaintsRequestValidation: {
    typeError: false,
    orderError: false,
    titleError: false,
    descriptionError: false,
  },
  complaintsTypes: [],
  storeRequestLoading: false,
  complaintsRequestError: false,
  file: undefined,
  complaintSubmitted: false,
};

function clientComplaintsReducer(state = initialState, action: any) {
  switch (action.type) {
    case ClientComplaintsActionTypes.SET_CLIENT_COMPLAINTS_LIST:
      return {
        ...state,
        complaintsList: action?.data?.complaintsList,
        dataLoading: false,
        lastPage: action?.data?.lastPage,
        currentPage: state.currentPage + 1,
        extendedListLoading: false,
      };

    case ClientComplaintsActionTypes.GET_CLIENT_EXTENDED_COMPLAINTS_LIST:
      return {
        ...state,
        extendedListLoading: true,
      };

    case ClientComplaintsActionTypes.SET_CLIENT_COMPLAINTS_INITIAL:
      return {
        ...initialState,
      };

    case ClientComplaintsActionTypes.TOGGLE_COMPLAINTS_MODAL:
      return {
        ...state,
        complaintsModal: !state.complaintsModal,
        complaintsRequest: initialState.complaintsRequest,
        complaintsRequestValidation: initialState.complaintsRequestValidation,
        complaintsRequestError: initialState.complaintsRequestError,
        file: initialState.file,
      };

    case ClientComplaintsActionTypes.SET_INITIAL_REQUEST_COMPLAINTS:
      return {
        ...state,
        complaintsModal: true,
        complaintsRequest: {
          ...state.complaintsRequest,
          order_id: action?.data?.orderId,
        },
        complaintsRequestValidation: {
          ...state.complaintsRequestValidation,
          orderError: !action?.data?.orderId,
        },
      };

    case ClientComplaintsActionTypes.SET_COMPLAINTS_REQUEST: {
      let errorKey = '';
      switch (action?.data?.key) {
        case 'type_id':
          errorKey = 'typeError';
          break;
        case 'title':
          errorKey = 'titleError';
          break;
        case 'description':
          errorKey = 'descriptionError';
          break;
      }

      return {
        ...state,
        complaintsRequest: {
          ...state.complaintsRequest,
          [action?.data?.key]: action?.data?.value,
        },
        complaintsRequestValidation: {
          ...state.complaintsRequestValidation,
          [errorKey]: !action?.data?.value,
        },
      };
    }

    case ClientComplaintsActionTypes.SET_COMPLAINTS_TYPES:
      return {
        ...state,
        complaintsTypes: action?.data?.complaintsTypes,
      };

    case ClientComplaintsActionTypes.STORE_COMPLAINTS_REQUEST:
      return {
        ...state,
        storeRequestLoading: true,
      };

    case ClientComplaintsActionTypes.SET_STORE_LOADING:
      return {
        ...state,
        storeRequestLoading: action?.data?.loading,
      };

    case ClientComplaintsActionTypes.SET_DATA_VALIDATION:
      return {
        ...state,
        complaintsRequestValidation: {
          orderError: !state.complaintsRequest.order_id,
          descriptionError: !state.complaintsRequest.description,
          titleError: !state.complaintsRequest.title,
          typeError: !state.complaintsRequest.type_id,
        },
        complaintsRequestError: !state.complaintsRequest.order_id ||
          !state.complaintsRequest.description ||
          !state.complaintsRequest.title ||
          !state.complaintsRequest.type_id,
      };

    case ClientComplaintsActionTypes.SET_COMPLAINTS_FILE:
      return {
        ...state,
        file: action?.data?.file,
      };

    case ClientComplaintsActionTypes.SET_COMPLAINT_SUBMITTED:
      return {
        ...state,
        complaintSubmitted: action?.data?.complaintSubmitted,
      };

    default:
      return state;
  }
}

export default clientComplaintsReducer;
